import { ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

declare module '@mui/material/Select' {
  interface SelectPropsSizeOverrides {
    large: true;
  }
}

/**
 * Theme override for MUI Select component
 *
 * Size heights (inherited from InputBase):
 * - Small: 32px
 * - Medium: 36px
 * - Large: 44px
 */
export const MuiSelect: ThemeOptions['components']['MuiSelect'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '.Mui-readOnly': {
        color: theme.palette.text.disabled,
        background: theme.palette.action.hover
      }
    }),
    select: ({ ownerState }) => ({
      fontSize: capitalDesignTokens.componentFontSizes.medium,
      ...(ownerState.size === 'small' && {
        minHeight: `${capitalDesignTokens.componentSizes.small}px`,
        fontSize: capitalDesignTokens.componentFontSizes.small
      }),
      ...(ownerState.size === 'large' && {
        minHeight: `${capitalDesignTokens.componentSizes.large}px`,
        fontSize: capitalDesignTokens.componentFontSizes.large
      })
    })
  }
};
